__turbopack_context__.v({
  "crownIcon": "TopOrganizerLabel-module-scss-module__VOn6Rq__crownIcon",
  "label": "TopOrganizerLabel-module-scss-module__VOn6Rq__label",
});
